// this is an autogenerated file from DesignSystem/CreateNewProfessionalModal/Details/Office/Search/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CreateNewProfessionalModal_Details_Office_Search_Content($current_location_xid: String!, $user_id: uuid!) {
  app_admin_users_access(
    where: { xid: { _eq: $current_location_xid }, user_id: { _eq: $user_id } }
    order_by: { organization_name: asc }
  ) {
    id
    organization_id
  }
}

`